"use strict";
// let _events = ['boarded', 'fire', 'ship', 'nothing', 'hull-breach', 'bomb']
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.EVoyageWaveType = void 0;
var EVoyageWaveType;
(function (EVoyageWaveType) {
    EVoyageWaveType[EVoyageWaveType["Default"] = -1] = "Default";
    EVoyageWaveType[EVoyageWaveType["Null"] = 0] = "Null";
    EVoyageWaveType[EVoyageWaveType["BoardedByAliens"] = 1] = "BoardedByAliens";
    EVoyageWaveType[EVoyageWaveType["Fire"] = 2] = "Fire";
    EVoyageWaveType[EVoyageWaveType["HullBreach"] = 3] = "HullBreach";
    EVoyageWaveType[EVoyageWaveType["Bomb"] = 4] = "Bomb";
    EVoyageWaveType[EVoyageWaveType["AlienShip"] = 5] = "AlienShip";
})(EVoyageWaveType = exports.EVoyageWaveType || (exports.EVoyageWaveType = {}));
var _default = {
    amount: 1,
    magnitude: 1,
    postWaveTime: 2,
    waitTillClear: true,
    type: EVoyageWaveType.Null,
};
function create(type, args) {
    return Object.assign({}, _default, args, { type: type });
}
exports.create = create;
